/**
 * Created by apop on 06/09/2018.
 */
angular
    .module('annexaApp')
    .component('annexaTransactionSubprocedure', {
        templateUrl: './components/tram/annexa-transaction-subprocedure/annexa-transaction-subprocedure.html',
        controller: ['Language', 'TramNewFactory','$rootScope', 'GlobalDataFactory', '$filter', 'globalModals', 'AnnexaFormlyFactory', 'DialogsFactory', 'AnnexaPermissionsFactory', 'apiAdmin', 'RestService', '$scope', function (Language, TramNewFactory, $rootScope, GlobalDataFactory, $filter, globalModals, AnnexaFormlyFactory, DialogsFactory, AnnexaPermissionsFactory, apiAdmin, RestService, $scope) {
            var vm = this;
            vm.languageColumn = "language1";
			$scope.$on('newSubprocessSelected', function(event, args) {
				vm.data.transaction = undefined;
				vm.data.listTransaction = undefined;
				vm.data.graphNodeType = undefined;
	            if(args && args.item && args.item.id){
					if(vm.data && vm.data.subprocedures && vm.data.subprocedures.length > 0){
						var t = $linq(vm.data.subprocedures).firstOrDefault(undefined, "x => x.procedure && x.procedure.id == "+args.item.id);
						if(t && t.listTrans && t.listTrans.length > 0) {
							vm.data.listTransaction = t.listTrans;
							vm.data.graphNodeType = t.graphNodeType;
							_.forEach(vm.data.listTransaction, function (item) {
								item.disabledProfile = false;
								item.showListProfile = false;
								if(vm.selectType(3, vm.data.graphNodeType, false)) {
									item.active = true;
								}
								if(item.processProfiles && item.processProfiles.length == 1) {
                            		item.profile = {
                            				id: item.processProfiles[0].profile.id,
                            				value: item.processProfiles[0].profile[vm.languageColumn],
                            				userProfiles: item.processProfiles[0].profile.userProfiles
                            		};
                            		item.disabledProfile = true;
                            	} else if(item.processProfiles && item.processProfiles.length > 0) {
    								item.showListProfile = true;
                            	} else if(item.selectProfiles && item.selectProfiles.length == 1) {
                            		item.profile = {
                            				id: item.selectProfiles[0].profile.id,
                            				value: item.selectProfiles[0].profile[vm.languageColumn],
                            				userProfiles: item.selectProfiles[0].profile.userProfiles
                            		};
                            		item.disabledProfile = true;
                            	} else if(item.selectProfiles && item.selectProfiles.length > 0) {
    								item.showListProfile = true;
                            	}
                            });
						} else if(t && t.trans){
							vm.data.transaction = t.trans;
						}
					}		
				}
	        });
			vm.showUsersProfiles = false;
            vm.loadProfilesFunction = function (value) {
                if (!value || !value.val) {
                    return [];
                } else if (value.val != '*' && value.val.length < 3) {
                    return [];
                } else {
                    if (value.val == '*') {
                        value.val = '';
                    }
                    return RestService.filterData('common', 'Profile', {}, {search: value.val, langColumn:vm.languageColumn}, 0, 10, '', 3).then(function (data) {
                        var items = [];
                        if (data.data && data.data.content) {
                            _.forEach(JSOG.decode(data.data.content), function (item) {
                                items.push({id: item.id, value: item[vm.languageColumn], userProfiles:item.userProfiles});
                            })
                        }
                        return items;
                    }).catch(function () {
                        return [];
                    });
                }
            };

            vm.getUserProfilesDTIProfile = function (profile) {
            	var userProfiles = [];
            	if(profile && profile.userProfiles){
            		_.forEach(profile.userProfiles, function (value, key) {
            			userProfiles.push(value);
            		});
            	} else if (profile && profile.profile && profile.profile.userProfiles) {
            		_.forEach(profile.profile.userProfiles, function (value, key) {
            			userProfiles.push(value);
            		});
            	}
            	return userProfiles;
            }
            
            vm.changeProfile = function(item, transaction) {
            	transaction.responsibleUser = undefined;
            }
            
            vm.getListProfiles = function(transaction) {
            	var listProfiles = [];
            	if(transaction.selectProfiles && transaction.selectProfiles.length > 0) {
            		listProfiles = transaction.selectProfiles;
            	} else if (transaction.processProfiles && transaction.processProfiles.length > 0) {
            		listProfiles = transaction.processProfiles;
            	}
            	return listProfiles;
            }
            
            vm.selectType = function (type, graphNodeType, actual) {
                if (actual && graphNodeType != 'SelectOne' && graphNodeType != 'SelectMultipleOpen') {
                    return false
                } else {
                    if (type == 1) {
                        if (graphNodeType == 'SelectMultipleOpen') {
                            return true;
                        } else {
                            return false;
                        }

                    } else if (type == 2) {
                        if (graphNodeType == 'SelectOne') {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        if (vm.selectType(1, graphNodeType, actual) || vm.selectType(2, graphNodeType, actual)) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                }
            };

            vm.clickObject = function (transaction) {
                if (vm.data.listTransaction) {
                    _.forEach(vm.data.listTransaction, function (value, key) {
                        if (transaction.graphNodeId != value.graphNodeId) {
                            value.active = false;
                        }
                    });
                }
            };
            
			this.$onInit = function () {
				vm.datatransaction = undefined;
				vm.languageColumn = Language.getActiveColumn();
            	vm.showUsersProfiles = (($rootScope.app && $rootScope.app.configuration &&  $rootScope.app.configuration.assign_responsible_user && $rootScope.app.configuration.assign_responsible_user.dossierTransaction && 
					($rootScope.app.configuration.assign_responsible_user.dossierTransaction == 'Obligatoria' || $rootScope.app.configuration.assign_responsible_user.dossierTransaction == 'Opcional')) || $rootScope.esetMode);
			}
			
        }],
        bindings: {
            data: '='
        }
    })